// 级别 ，科目， 课程 的 选择框
import axios from '@/libs/api.request'
import ViewUI from 'view-design'
  const state = {
    curseList: [],
    gradeList: [],
    subjectList: [],
    provinceList: [],
    cityList: [],
    areaList: [],
    leftMenu: [],
    labelMsg: 'hep',
    labelMsgAccount: '个人账户'
  }
  const mutations = {
    SET_CURSE_LIST(state, data) {
      state.curseList = data
    },
    SET_GRADE_LIST(state, data) {
      state.gradeList = data
    },
    SET_SUBJECT_LIST(state, data) {
      state.subjectList = data
    },
    SET_PROVINCE_LIST(state, data) {
      state.provinceList = data
    },
    SET_CITY_LIST(state, data) {
      state.cityList = data
    },
    SET_AREA_LIST(state, data) {
      state.areaList = data
    },
    SET_LEFT_MENU(state, data) {
      state.leftMenu = data
    },
    SET_LABEL_MSG(state, data) {
      state.labelMsg = data
    },
    SET_LABEL_MSG_ACCOUNT(state, data) {
      state.labelMsgAccount = data
    }
  }
  const actions = {
    getAllSelect ({commit}) {
      const a = new Promise((resolve, reject) => {
        axios.get('/app/curse/getList').then(res => {
          if(res.code == 1) {
            commit('SET_CURSE_LIST', res.data)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
      })
      const b = new Promise((resolve, reject) => {
        axios.get('/app/grade/getGrade').then(res => {
          if(res.code == 1) {
            commit('SET_GRADE_LIST', res.data)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
        
      })
      const c = new Promise((resolve, reject) => {
        axios.get('/app/subject/getSubject').then(res => {
          if(res.code == 1) {
            commit('SET_SUBJECT_LIST', res.data)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
        
      })
      return Promise.all([a, b, c]).then(res => {});
    }
  }
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  